import { render } from "./End.vue?vue&type=template&id=3c8349c6"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"

import "./End.vue?vue&type=style&index=0&id=3c8349c6&lang=css"

import exportComponent from "C:\\Users\\Kama484\\Monopoly\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__